import { render, staticRenderFns } from "./ImportPaymentForm.vue?vue&type=template&id=e878bbdc&scoped=true&"
import script from "./ImportPaymentForm.vue?vue&type=script&lang=js&"
export * from "./ImportPaymentForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e878bbdc",
  null
  
)

export default component.exports